<template>
  <div id="app">
    <!-- -------------------- 头像1 ------------------------- -->
    <div
      class="iw-content-saasbanner"
      style="display: block;top:180px;"
      @click="userclik()"
      v-show="!$route.meta.navshow"
    >
      <div class="user-content">
        <div
          class="user-head"
          id="iw_userhead_click"
          :style="{ backgroundImage: 'url(' + logoimg + ')' }"
        ></div>

        <div class="user-title">
          <div class="text">怀山望</div>
        </div>
      </div>

      <div class="extend-content onShowing" :style="{ display: detailed }">
        <div class="user-info-split-line"></div>
        <div class="user-info">
          <span class="userinfo-name">怀山望</span>
          <span
            style="pointer-events: all"
            id="iw-userinfo-phone"
            class="userinfo-phone"
            >021 - 5075 9777</span
          >
        </div>
      </div>
    </div>

    <!-- -------------------- 控制按钮 ------------------------- -->

    <div
      class="iw-content-side"
      style="height: 36px; transition: height 0.3s ease 0s; display: block;"
      :style="{ height: rightnavheight }"
      v-show="!$route.meta.navshow"
    >
      <div class="iw-group" style="display: block;">
        <div
          class="iw-ui-switch-menu side_group"
          @click="rightclik()"
          :class="{ action: rightShow }"
          style="display: block;"
        ></div>

        <div
          type="iw-icon-switch-music"
          class="iw-icon-switch-music showing"
          :class="{ action: musicstatus }"
          @click="musicplay()"
          iw-clk-param="background"
          is_on="true"
          style="height: 28px; margin: 4px; opacity: 1; transition: height 0s ease 0s, margin 0s ease 0s, opacity 0.3s ease 0s, all 0.3s ease 0s, all 0.3s ease 0s; display: block;"
        ></div>

        <div class="iw-icon-switch-phone">
          <a href="tel:021 - 5075 9777" style="font-size:20px"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a
          >
        </div>

        <!-- <div class="iw-icon-switch-map" id="openLocation"></div> -->
        <div class="iw-icon-switch-map mapapi"></div>
      </div>
    </div>
    <!-- <div
      style="width: 100px;height: 100px;position: absolute;z-index: 9999;"
      v-show="mushow"
    >
      音乐加载中
    </div> -->
    <!-- 音乐播放 -->
    <!-- v-if="musicstatus" -->
    <audio
      :src="mp3Url"
      autoplay="autoplay"
      loop
      id="mp3"
      v-if="musicstatus"
    ></audio>

    <!-- <keep-alive> -->
    <router-view />
    <!-- </keep-alive> -->
    <Tabbar></Tabbar>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Tabbar from "@/components/Tabbar";
import Toch from "@/components/Toch";
import wx from "weixin-js-sdk";

import axios from "axios";
import $ from "jquery";
export default {
  data() {
    return {
      isShow: true,
      navurl: "",
      mushow: true,
      musicstatus: true,
      logoimg: "./static/logo.jpg",
      mp3Url: "./static/BGM.mp3",
      detailedshow: false,
      detailed: "none",
      rightShow: true,
      count: 0,
      //  rightnavheight: "146px"
      rightnavheight: "auto"
    };
  },
  mounted() {
    this.$nextTick(() => {
      // this.audioAutoPlay();
      setTimeout(() => {
        this.goWxchat();
      }, 1000);
      let audio = document.getElementById("mp3");

      let musicplays = setInterval(() => {
        if (audio.duration > 0 && !audio.paused) {
        } else {
          if (this.musicstatus) {
            audio.play();
            document.addEventListener(
              "WeixinJSBridgeReady",
              function() {
                audio.play();
              },
              false
            );
          } else {
            clearInterval(musicplays);
          }
        }
      }, 1000);
    });

    // if(count > 20){
    //   ce
    // }
    console.log(`旧值：${this.$store.state.number}`);
    // this.$store.commit('setNumberIsWhat', 888);
  },
  components: {
    Tabbar,
    Toch
  },
  computed: {
    ...mapState(["name"]), // 经过解构后，自动就添加到了计算属性中，此时就可以直接像访问计算属性一样访问它
    ...mapGetters(["getMessage"])
  },

  methods: {
    async goWxchat() {
      // let url = encodeURIComponent(location.href.split("#")[0]);
      let url = location.href.split("#")[0];
      // console.log(url);
      let data = {
        url
      };

      // const res = await reqConfigSignature(data);
      axios({
        method: "post",
        url: "https://720yun.gugushuzi.com/tour.php?act=jssdk",
        params: {
          currentUrl: url
        }
      }).then(res => {
        // console.log(res); /* 将拿到的值，赋值给data */
        // const res = res.data;
        if (res.status === 200) {
          //拿到后端给的这些数据
          let appId = res.data.appId;
          let timestamp = res.data.timestamp;
          let nonceStr = res.data.nonceStr;
          let signature = res.data.signature;
          let linkimg =
            "https://720yun.gugushuzi.com/project/huaishanwang/logo.jpg";
          let title = "怀山望";
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId, // 必填，公众号的唯一标识，填自己的！（开发者账号）
            timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
            nonceStr, // 必填，生成签名的随机串
            signature, // 必填，签名，见附录1
            jsApiList: [
              "updateTimelineShareData",
              "updateAppMessageShareData",
              "openLocation",
              "getLocation"
            ]
          });
          wx.ready(function(res) {
            //分享到朋友圈
            wx.updateTimelineShareData({
              title: title, // 分享时的标题
              link: url, // 分享时的链接  如果项目域名与JS接口安全域名不一致 可以采用此方式
              imgUrl: linkimg, // 分享时的图标
              success: function() {
                console.log("分享成功");
              },
              cancel: function() {
                console.log("取消分享");
              }
            });
            document.querySelector(".mapapi").onclick = function() {
              wx.openLocation({
                latitude: 31.048883,
                longitude: 121.726518,
                name: "怀山望城市会客厅",
                address: "上海市浦东新区人民西路1523号",
                scale: 14,
                infoUrl: "http://www.ilanluo.com"
              });
            };
            //分享给朋友
            wx.updateAppMessageShareData({
              title: title,
              desc: "心有山水 自成境",
              link: url,
              imgUrl: linkimg,
              type: "",
              dataUrl: "",
              success: function() {
                console.log("分享成功");
              },
              cancel: function() {
                console.log("取消分享");
              }
            });
          });

          wx.error(function(res) {
            console.log("回调失败", res);
          });
        }
      });
    },

    musicplay() {
      this.musicstatus = !this.musicstatus;
      if (this.musicstatus) {
        this.$nextTick(() => {
          this.audioAutoPlay();
        });
      }
      return false;
    },
    audioAutoPlay() {
      let audio = document.getElementById("mp3");
      audio.play();
      document.addEventListener(
        "WeixinJSBridgeReady",
        function() {
          audio.play();
        },
        false
      );
    },
    rightclik() {
      this.rightShow = !this.rightShow;
      if (this.rightShow) {
        this.rightnavheight = "auto";
      } else {
        this.rightnavheight = "36px";
      }
    },
    userclik() {
      this.detailedshow = !this.detailedshow;
      if (this.detailedshow) {
        this.detailed = "block";
      } else {
        this.detailed = "none";
      }
    }
  },
  watch: {
    "$store.state.number": function() {
      console.log(`新值：${this.$store.state.number}`);
      if (this.$store.state.number === 888) {
        this.musicstatus = !this.musicstatus;
      }
      if (this.$store.state.number === 999) {
        this.musicstatus = !this.musicstatus;
      }
    }
  }
};
</script>

<style>
.iw-html-frame {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  padding: 0;
  margin: 0;
  border: 0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue